import {
    Badge,
    BlockStack,
    Card,
    InlineGrid,
    InlineStack,
    Modal,
    Select,
    Text,
} from '@shopify/polaris';
import React, { useContext, useEffect, useState } from 'react';
import MultiLangFeedbackForm from './MultiLangFeedbackForm';
import { DI, DIProps } from '../../../../../Core'
import { useTranslation } from 'react-i18next';
import { MultiLangPreference } from '../../../../../Asests/svgIcon/icon';
import { StoreDispatcher } from "../../../../../index";
import { saveConfigSourceOnly } from "../../../index";

export interface Props extends DIProps {
    syncNecessaryInfo: () => void;
    syncConnectorInfo: (props: any, shop_url?: string | null, updateCurrentShop?: boolean, updateStepStatus?: React.Dispatch<React.SetStateAction<string>>) => void;
    syncProfileInfo: () => void;
    loginStatus: () => void;
    syncServices: () => void;
}

const MultiLangSetting = (props: Props) => {
    const dispatcher: any = useContext(StoreDispatcher);
    const { i18n, t } = useTranslation()
    const [open, setOpen] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [selectedLanguage, setSelectedLanguage] = useState(props?.redux?.language ?? 'en');
    const [feedbackFormActive, setFeedbackFormActive] = useState(false);

    const languages = [
        { label: 'English (Default)', value: 'en' },
        { label: 'हिंदी', value: 'hn' },
        { label: 'Deutsch', value: 'gr' },
        { label: 'Français', value: 'fr' },
        // { label: 'Português', value: 'pr' },
        { label: 'Español', value: 'sp' },
        // { label: 'العربية', value: 'ar' },
        // { label: 'Nederlands', value: 'du' },
        // { label: 'Italiano', value: 'it' },
        // { label: 'Polski', value: 'po' },
        // { label: 'Svenska', value: 'sw' },
        // { label: 'Türkçe', value: 'tr' },
        // { label: '日本語', value: 'jp' },
        // { label: 'Afrikaans', value: 'af' },
    ];

    const handleClose = () => {
        setSelectedLanguage(props?.di?.globalState?.get('language') ?? 'en');
        setConfirm(!confirm)
    }

    useEffect(() => {
        // props.di.POST('connector/config/getConfig', {
        //     "group_code": ["language"]
        // }).then((response: any) => {
        //     if (response.success) {
        //         dispatcher({
        //             type: 'update_language',
        //             state: {
        //                 language: response?.data?.[0]?.value?.selectedLanguage ?? 'en',
        //             },
        //         });
        //         setSelectedLanguage(response?.data?.[0]?.value?.selectedLanguage ?? 'en');
        //         props?.di?.globalState?.set('language', response?.data?.[0]?.value?.selectedLanguage ?? 'en');
        //     } else {
        //         props.error(t(response.message));
        //     }
        // });

        if (props?.redux?.language) {
            setSelectedLanguage(props?.redux?.language ?? 'en');
        }
    }, [props?.redux?.language]);

    const handleLanguageChange = async () => {
        // props.di.POST('connector/config/saveConfig', {
        //     "data": [
        //         {
        //             "data": {
        //                 selectedLanguage: selectedLanguage
        //             },
        //             "group_code": "language"
        //         }
        //     ]
        // }).then((response: any) => {
        //     if (response.success) {
        //         dispatcher({
        //             type: 'update_language',
        //             state: {
        //                 language: selectedLanguage ?? 'en',
        //             },
        //         });
        //         // setSelectedLanguage(selectedLanguage);
        //         i18n.changeLanguage(selectedLanguage);
        //         props.di.globalState.set('language', selectedLanguage);
        //         setConfirm(!confirm);
        //     } else {
        //         props.error(t(response.message))
        //     }
        // });

        let response = await saveConfigSourceOnly("language", selectedLanguage ?? 'en', props);
        if (response.success) {
            dispatcher({
                type: 'update_language',
                state: {
                    language: selectedLanguage ?? 'en',
                },
            });
            i18n.changeLanguage(selectedLanguage);
            props.di.globalState.set('language', selectedLanguage);
            setConfirm(!confirm);
        } else {
            props.error(t(response.message))
        }
    }

    return (
        <React.Fragment>
            <Card background='bg-surface'>
                <InlineGrid columns={{ xs: 1, sm: 1, md: 2, lg: ['twoThirds', 'oneThird'], xl: ['twoThirds', 'oneThird'] }} gap={"300"}>
                    <InlineStack gap={"200"}>
                        <MultiLangPreference />
                        <BlockStack gap={"050"}>
                            <InlineStack gap={"200"}>
                                <Text as='p' variant='bodyLg' fontWeight='medium'>{t("Language Preference")}</Text>
                                <Badge size='medium'>{languages.filter((language: any) => language.value == selectedLanguage)[0].label}</Badge>
                            </InlineStack>
                            <Text as='p' variant='bodyMd'>{t("Switch app to your preferred language.")}</Text>
                        </BlockStack>
                    </InlineStack>
                    <Select
                        label=""
                        options={languages}
                        onChange={(e) => {
                            setSelectedLanguage(e);
                            setConfirm(true);
                        }}
                        value={selectedLanguage}
                    />
                </InlineGrid>
            </Card>
            <Modal
                open={confirm}
                onClose={() => handleClose()}
                // update this title content
                title={t("Change Language")}
                primaryAction={{
                    content: t('Confirm'),
                    onAction: handleLanguageChange,
                }}
                secondaryActions={[
                    {
                        content: t('Cancel'),
                        onAction: handleClose,
                    },
                ]}>
                <Modal.Section>
                    <Text as="p" variant="bodyMd">
                        {`${t("Are you sure you want to change the language to")} ${languages.filter((lang: any) => lang.value == selectedLanguage)[0].label}?`}
                    </Text>
                </Modal.Section>
            </Modal>
        </React.Fragment>
    );
};

export default DI(MultiLangSetting);